import intersection from "lodash/intersection"
import type { TActivityType } from "@/types"
import { useAuth } from "./useAuth"
import { useConfig } from "./useConfig"

interface IProps {
  activity?: TActivityType
  teamIds?: string[]
}

export function usePermissions({ activity, teamIds }: IProps = {}) {
  const { user } = useAuth()
  const config = useConfig()

  if (!user) return {}

  const isSuper = user.is_super,
    isOwner = user.role == "owner",
    isAdmin = isOwner || user.role == "admin",
    isSectionAdmin = isAdmin || (activity && !!config?.sections?.[activity]?.admin_ids?.includes(user.id)),
    isManager = isAdmin || (user.role == "manager" && (!teamIds || intersection(teamIds, user.team_ids).length > 0))

  return {
    user,
    isSuper,
    isOwner,
    isAdmin,
    isManager,
    isSectionAdmin,
  }
}
